import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { truncate } from "lodash";
import { caseAlertMarkRead } from "actions/CaseAlerts";
import { setQASwitchCaseDialog } from "actions/qualityAssurance";

class CaseAlerts extends React.Component {
  constructor(props) {
    super(props);
    this.getIcon = this.getIcon.bind(this);
    this.getIconClassName = this.getIconClassName.bind(this);
    this.mapCaseAlertsToMenuItems = this.mapCaseAlertsToMenuItems.bind(this);
    this.mapActionToIcon = this.mapActionToIcon.bind(this);
    this.newCaseAlerts = this.newCaseAlerts.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.rootRef = React.createRef();
    this.state = {
      anchorEl: null,
      newCaseAlerts: this.newCaseAlerts()
    };
  }

  componentDidUpdate() {
    const newCaseAlerts = this.newCaseAlerts();
    if (this.state.newCaseAlerts !== newCaseAlerts)
      this.setState({
        newCaseAlerts: newCaseAlerts
      });
  }

  handleClick(event) {
    this.setState({ anchorEl: event.currentTarget });
  }

  handleClose() {
    this.setState({ anchorEl: null });
  }

  getIcon() {
    const { newCaseAlerts } = this.state;
    if (newCaseAlerts) return "notifications";
    return "notifications_none";
  }

  getIconClassName() {
    const { anchorEl } = this.state;
    return `md-icon material-icons${anchorEl ? " active" : " inactive"}`;
  }

  mapCaseAlertsToMenuItems() {
    const { caseAlerts, caseAlertMarkRead, setQASwitchCaseDialog } = this.props;
    if (!caseAlerts || !caseAlerts.length)
      return (
        <MenuItem disabled>
          <ListItemText primary="No Case Alerts" />
        </MenuItem>
      );
    let alerts = caseAlerts.map(({ isNew, id, action, controlNumber, customerNumber, customerName, message, timeStamp, qaQueueTypeId }) => {
      return (
        <MenuItem
          key={id}
          className={isNew ? "unread" : ""}
          onClick={() => {
            caseAlertMarkRead(id);
            if (qaQueueTypeId === 1) {
              navigator.clipboard.writeText(controlNumber);
            } else {
              setQASwitchCaseDialog(true, controlNumber);
              this.handleClose();
            }
          }}
        >
          <ListItemIcon>
            <Icon title={action}>{this.mapActionToIcon(action)}</Icon>
          </ListItemIcon>
          <ListItemText
            primary={`${controlNumber} : ${customerName} (${customerNumber})`}
            secondary={`${truncate(message, { length: 70 })} - ${action} ${timeStamp}`}
          />
        </MenuItem>
      );
    });
    alerts.push(
      <MenuItem
        key="mark-all-read"
        className="md-btn md-btn--raised mark-read"
        onClick={() => {
          caseAlerts.forEach(s => caseAlertMarkRead(s.id));
          this.handleClose();
        }}
      >
        <ListItemText primary="Mark All as Read" />
      </MenuItem>);
    return alerts;
  }

  mapActionToIcon(action) {
    switch (action) {
      case "Returned by Manager":
      case "Returned from Field":
      default:
        return "message";
    }
  }

  newCaseAlerts() {
    const { caseAlerts } = this.props;
    if (caseAlerts)
      return caseAlerts.find(caseAlert => caseAlert.isNew) || false;
    return false;
  }

  render() {
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);
    return (
      <>
        <IconButton
          id="case-alerts"
          className={this.getIconClassName()}
          onClick={this.handleClick}
          ref={this.rootRef}
        >
          <Icon>{this.getIcon()}</Icon>
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={this.handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          {this.mapCaseAlertsToMenuItems()}
        </Menu>
      </>
    );
  }
}

CaseAlerts.defaultProps = {
  place: "bottom",
  caseAlerts: null
};

CaseAlerts.propTypes = {
  //pure props
  place: PropTypes.string,

  //global state
  caseAlerts: PropTypes.array,
  rights: PropTypes.array,

  //actions
  caseAlertMarkRead: PropTypes.func,
  setQASwitchCaseDialog: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
  return {
    caseAlerts: state.caseAlerts,
    rights: state.user.profile.rights,
  };
};

const mapDispatchToProps = dispatch => ({
  caseAlertMarkRead(id) {
    dispatch(caseAlertMarkRead(id));
  },
  setQASwitchCaseDialog(shouldShowCompletedCaseDialog, controlNumber) {
    dispatch(setQASwitchCaseDialog(shouldShowCompletedCaseDialog, controlNumber));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CaseAlerts);
